import { GraphicsService } from "appworks/graphics/graphics-service";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Point } from "appworks/utils/geom/point";
import { gameLayers } from "game-layers";
import { ShowWinLinesState } from "slotworks/state-machine/standard/states/show-win-lines-state";

export class FowlSlotShowWinsState extends ShowWinLinesState {
    protected winBoxes: Sprite[] = [];

    public onEnter(): void {
        super.onEnter();
        uiFlags.set(UIFlag.NO_SKIP, false);
    }

    public onExit(): void {
        this.winBoxes.forEach(box => box.destroy());
        this.winBoxes = [];

        super.onExit();
    }

    public onSkip(): void {
        uiFlags.set(UIFlag.NO_SKIP, true);
        this.contract.cancel();
        this.skip();
    }

    protected highlightWins(): Contract<void> {
        // Get array of unique win positions
        const record = gameState.getCurrentGame().getCurrentRecord();
        const wins = this.getWinsToShow(record);
        const positions: Point[] = [];
        for (const result of wins) {
            for (const position of result.positions) {
                if (!positions.find(pos => pos.equals(position))) {
                    positions.push(position);
                }
            }
        }

        // Show winboxes
        positions.forEach(pos => {
            const box = Services.get(GraphicsService).createSprite("slotbonus_winbox");
            this.winBoxes.push(box);
            gameLayers.MatrixBackground.add(box);

            const symbolPos = gameLayers.MatrixContent.getPosition(`symbol_${pos.x}_${pos.y}`);
            box.setDualPosition(symbolPos);
        });

        if (wins.length > 0) {
            Services.get(SoundService).customEvent("slot_fanfare");
        }

        return Contract.getTimeoutContract(wins.length ? 1000 : 0);
    }

    protected tickUpTotalWin(time: number): void {
        return;
    }
}
